import { Typography } from 'antd';
import React from 'react';
import './form-imput-description.styles.less';

const { Text } = Typography;

interface FormInputDescriptionProps {
  text?: string;
  strong?: boolean;
}

export const FormInputDescription: React.FC<FormInputDescriptionProps> = ({ text, strong }) => (
  <Text strong={strong} type="secondary" className="form-input-description">
    {text}
  </Text>
);
